import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiPageTemplate, EuiPageHeader, EuiImage } from '@elastic/eui';
import styled from 'styled-components';
import { Header } from '../components/header';
import { Footer } from '../components/footer';
import work4image2 from '../../documents/work4image2.png'
import work4image3 from '../../documents/work4image3.png'

const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-gap: 0 10px;
    padding: 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '• ';
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
class Work4 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            isModalVisible: false,
            files: {},
            uploadDisabled: true,
            selection: [],
            columns: [],
            AlertText: "",
            AlertType: "error",
            internship2Key: ['Project Cost - $ 50K','	Daily monitoring & controlling of resources ','	Planning and scheduling of work - 10 km area',
                   '	Resource allocation and management of 40+ interns','Studied 3 waste disposal units','1700+ data sorting and data visualization (MS Excel & Power BI)','Legal permission from local government bodies'

                ],
            internship2Value: ['Techno-Management Skill-  Enhancement of communication skills','Ability to analyse constraints and restraints',
        ],
    }
    }

    render() {

        return (
            <>
                <EuiPageTemplate>
                    <EuiPageHeader><Header /></EuiPageHeader>
                        <EuiSpacer />
                        <EuiText><h2><font face='Segoe UI'>Mantra Solid Waste Management Pvt. Ltd</font></h2></EuiText>
                        <EuiSpacer size='m' />
                        <EuiText><h5><font face='Segoe UI'>(February-April 2018)</font></h5></EuiText>
                        <EuiSpacer size='m' />
                <EuiFlexGroup gutterSize='xl'>
                <EuiFlexItem>
                        <EuiText><b>Position:</b> Management Internship<EuiSpacer size='m' /><b>Project: </b>Solid Waste Management Survey of Bibewadi, Pune
                        <EuiSpacer size='m' />
                          <b>Key Responsibilities</b> 
                        <StyledText><ul className="skills-list">
                        {this.state.internship2Key && this.state.internship2Key.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                        <b>Value Additions</b>
                        <StyledText><ul className="skills-list">
                        {this.state.internship2Value && this.state.internship2Value.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText></EuiText>
                </EuiFlexItem><div><EuiFlexGroup direction='column'>
                <EuiFlexItem ><EuiText textAlign='center'><EuiImage size='l' src={work4image2} /><br/>
                Data Collection @ Bibewadi,Pune Neighborhood</EuiText></EuiFlexItem>
                <EuiFlexItem><EuiImage size='l' src={work4image3} />
                <EuiText textAlign='center'>
                </EuiText></EuiFlexItem></EuiFlexGroup></div>
                </EuiFlexGroup>
            <Footer /></EuiPageTemplate>
            </>
        )
    }
};

export { Work4 }